import { render, staticRenderFns } from "./CheckListItemsForm.vue?vue&type=template&id=6a886714&"
import script from "./CheckListItemsForm.vue?vue&type=script&lang=js&"
export * from "./CheckListItemsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports